export const formWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  width: '100%',
  minWidth: '500px',
};

export const buttonsWrapperStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  mt: 2,
};
